import { redirectToLogin } from "./annoucement-sheet";
import { api, language } from "./api";
import authHeader from "./auth-header";
import { PaginationData } from "./employee";
export type DropdownDataWithLanguage = {
  id: number;
  name_en: string;
  name_tc: string;
  name_sc: string;
};
type DepartmentsResponse = {
  module_id: number;
  status: boolean;
  data: DepartmentInfo[];
  total: number;
};

export type TData = {
  data: DepartmentInfo[];
  total: number;
};
export type DepartmentInfo = {
  id?: number;
  name: string;
};
type departmentInput = {
  // sort: string;
  // search: string;
};
export type TaskDepartmentList = {
  TeamList: TaskDepartmentListData[];
};
export type PaginationDepartmentList = {
  TeamList: PaginationDepartmentListData;
};
export type PaginationDepartmentListData = {
  data:TaskDepartmentListData[];
  total: number;
};
export type TaskDepartmentListData = {
  id: number;
  name: string;
};
export type IDepartPaginationData = {
  page: number;
  limit: number | string | undefined;
  search: string | number;
  sort?: string;
};
export const sectionApi = api.injectEndpoints({
  endpoints: (build) => ({
    getTeams: build.query<
    any,
    IDepartPaginationData
    >({
      query: ({limit,page,search,sort}) => {
        return ({
          url: `teams?limit=${limit}&page=${page}&search=${search}&sort=${sort}`,
          headers: authHeader(),
        })
      },
      keepUnusedDataFor:0,
      transformErrorResponse: (err) => {
        if (err?.status === 401) {
          redirectToLogin();
        }
      },
    }),
    getTeamsWithPagination: build.query<
    PaginationDepartmentList,
    IDepartPaginationData
    >({
      query: ({limit,page,search,sort}) => {
        return ({
          url: `teams?limit=${limit}&page=${page}&search=${search}&sort=${sort}`,
          headers: authHeader(),
        })
      },
      keepUnusedDataFor:0,
      transformErrorResponse: (err) => {
        if (err?.status === 401) {
          redirectToLogin();
        }
      },
    }),
    getTeamsAllList: build.query<
    TaskDepartmentList,
      void
    >({
      query: () => ({
        url: `getTeamList`,
        headers: authHeader(),
      }),
      keepUnusedDataFor:0,
      transformErrorResponse: (err) => {
        if (err?.status === 401) {
          redirectToLogin();
        }
      },
    }),
    getTeamsAllListBySection: build.query<TaskDepartmentList,any>({
      query: ({ section_ids }) => {
        const params = new URLSearchParams();
        if (section_ids) {
          params.append("section_ids", section_ids);
        }
        const queryString = params.toString();
          const url = queryString
          ? `getTeamList?${queryString}`
          : `getTeamList`;
          
        return {
          url: url,
          headers: authHeader(),
        }
      },
      keepUnusedDataFor:0,
      transformErrorResponse: (err) => {
        if (err?.status === 401) {
          redirectToLogin();
        }
      },
    }),
    createTeam: build.mutation<TaskDepartmentList, DropdownDataWithLanguage>({
      query(body) {
        return {
          headers: authHeader(),
          url: `teams`,
          body,
          method: "POST",
        };
      }
    }),
    updateTeam: build.mutation<TaskDepartmentList, DropdownDataWithLanguage>({
      query(body) {
        return {
          headers: authHeader(),
          url: `teams/${body.id}`,
          body,
          method: "PUT",
        };
      },
      // invalidatesTags: (employees) => {
      //   return [{ type: "Departments", id: "LIST" }];
      // },
    }),
    deleteTeam: build.mutation<TaskDepartmentList, number>({
      query(id) {
        return {
          headers: authHeader(),
          url: `/teams/${id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: (employees) => {
        return [{ type: "Teams", id: "LIST" }];
      },
    }),
  }),
});

export const {
    useCreateTeamMutation,
    useUpdateTeamMutation,
    useGetTeamsAllListQuery,
    useGetTeamsQuery,
    useDeleteTeamMutation,
    useGetTeamsWithPaginationQuery,
    useGetTeamsAllListBySectionQuery
} = sectionApi;

export const {
  endpoints: {
    createTeam,
    updateTeam,
    getTeams,
    getTeamsAllList,
    getTeamsWithPagination,
    deleteTeam,
    getTeamsAllListBySection
  },
} = sectionApi;
